import React from 'react';
import { Box, Typography, Card, CardMedia, Button, Grid } from '@mui/material';
import AndroidIcon from '@mui/icons-material/Android';
import QrCode2Icon from '@mui/icons-material/QrCode2';

const DownloadAppSection = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#15A67D',
        borderRadius: '24px',
        border: '2px solid #15A67D',
        py: 6,
        px: { xs: 3, md: 8 },
        mx: 'auto',
        maxWidth: '1200px',
        color: 'white',
      }}
    >
      <Grid
        container
        spacing={4}
        alignItems="center"
        justifyContent="center"
        direction={{ xs: 'column', md: 'row' }}
      >
        {/* Columna izquierda: texto + botón */}
        <Grid item xs={12} md={6}>
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            📱 App Móvil Chukuta Comunicaciones
          </Typography>
          <Typography variant="body1" mb={2}>
            Descarga nuestra aplicación móvil para celulares con sistema <strong>Android</strong>. Accede a nuestra señal en vivo desde cualquier punto de la ciudad o del mundo.
          </Typography>

          <Box display="flex" justifyContent="center">
            <Button
              variant="contained"
              startIcon={<AndroidIcon />}
              href="https://drive.google.com/file/d/16ZLfydg0DB7USdLHCGjbhQYUsFXufAab/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                backgroundColor: '#EF2F44',
                color: 'white',
                mt: 2,
                px: 3,
                py: 1,
                fontWeight: 'bold',
                '&:hover': {
                  backgroundColor: '#d7283b',
                },
              }}
            >
              DESCARGAR APLICACIÓN MÓVIL ANDROID
            </Button>
          </Box>
        </Grid>

        {/* Columna derecha: texto + QR */}
        <Grid item xs={12} md={6}>
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            mb={1}
            textAlign="center"
          >
            <QrCode2Icon sx={{ verticalAlign: 'middle', mr: 1 }} />
            Escanea el código QR para descargar
          </Typography>

          <Box display="flex" justifyContent="center">
            <Card
              sx={{
                width: { xs: '100%', sm: 250 },
                maxWidth: 300,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '16px',
                backgroundColor: 'white',
                p: 2,
              }}
            >
              <CardMedia
                component="img"
                image="/images/qr.png"
                alt="Código QR Chukuta"
                sx={{
                  width: '100%',
                  height: 'auto',
                  objectFit: 'contain',
                }}
              />
            </Card>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DownloadAppSection;
